import responseFields from '../../common/constants/responseFields'
import { propertyDetailSearchFields, realEstateGeneralFields } from '../../common/forms/generalRealEstate/fields'

export const LOCATION_VALUE_ENDPOINTS = {
    country: 'v1/core/locations/values/country',
    county: 'v1/core/locations/values/county',
    city: 'v1/core/locations/values/city',
    widerArea: 'v1/core/locations/values/widerArea',
    quarter: 'v1/core/locations/values/quarter',
    island: 'v1/core/locations/values/island',
} as const

export const ENDPOINT_FILTERS: Record<string, string[]> = {
    county: ['country'],
    city: ['county'],
    widerArea: ['city'],
    quarter: ['widerArea'],
    island: ['country'],
}

// Location fields to be cleared when a parent location field is cleared
export const LOCATIONS_RESET_CONFIG: Record<string, string[]> = {
    country: ['county', 'city', 'wider_area', 'quarter', 'island'],
    county: ['city', 'wider_area', 'quarter'],
    city: ['wider_area', 'quarter'],
    wider_area: ['quarter'],
}

// Location form field mappings (general forms - with _id suffix)
export const locationGeneralFieldsConfig = {
    country: realEstateGeneralFields.COUNTRY_ID,
    county: realEstateGeneralFields.COUNTY_ID,
    city: realEstateGeneralFields.CITY_ID,
    widerArea: realEstateGeneralFields.WIDER_AREA_ID,
    quarter: realEstateGeneralFields.QUARTER_ID,
    island: realEstateGeneralFields.ISLAND_ID,
}

// Location Detail Search form field mappings for Property search
export const locationPropertyDetailSearchFieldsConfig = {
    country: propertyDetailSearchFields.COUNTRY,
    county: propertyDetailSearchFields.COUNTY,
    city: propertyDetailSearchFields.CITY,
    widerArea: propertyDetailSearchFields.WIDER_AREA,
    quarter: propertyDetailSearchFields.QUARTER,
    island: propertyDetailSearchFields.ISLAND,
}

// Location Detail Search form field mappings for Contact/Company profile search (profileSelectOptions)
export const locationContactProfileDetailSearchFieldsConfig = {
    country: responseFields.COUNTRY,
    county: responseFields.COUNTY,
    city: responseFields.CITY,
    widerArea: responseFields.WIDER_AREA,
    quarter: responseFields.QUARTER,
}
